import { render, staticRenderFns } from "./AffiliateShare.vue?vue&type=template&id=4b4bd159&scoped=true"
import script from "./AffiliateShare.vue?vue&type=script&lang=js"
export * from "./AffiliateShare.vue?vue&type=script&lang=js"
import style0 from "./AffiliateShare.vue?vue&type=style&index=0&id=4b4bd159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bd159",
  null
  
)

export default component.exports